import { getLocale } from '../helpers.js';
/**
 * function: formatNumber
 * Example: any number value
 */
export function formatNumber({ number, language, subsidiary, options }) {
    const locale = getLocale(language, subsidiary);
    const numberFormat = new Intl.NumberFormat(locale, options);
    return numberFormat.format(number);
}
//# sourceMappingURL=formatNumber.js.map